// Suoni discreti per join / leave / REC. Web Audio API, no asset.
// Default ON. Toggle in Impostazioni; preferenza in localStorage.

const SETTING_KEY = 'ala-meet.sounds-on';

export const Sounds = {
  isOn(): boolean {
    const v = localStorage.getItem(SETTING_KEY);
    return v !== 'false';
  },
  toggle(): boolean {
    const v = !Sounds.isOn();
    localStorage.setItem(SETTING_KEY, String(v));
    return v;
  },

  join() { Sounds.play([392, 523, 659], 0.05, 0.12); },   // G4 C5 E5 ascending
  leave() { Sounds.play([659, 523, 392], 0.05, 0.12); },  // E5 C5 G4 descending
  rec()  { Sounds.play([880, 1108], 0.08, 0.15); },       // A5 C#6

  play(freqs: number[], gain = 0.05, dur = 0.12) {
    if (!Sounds.isOn()) return;
    let ctx: AudioContext;
    try {
      ctx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
    } catch {
      return;
    }
    const now = ctx.currentTime;
    freqs.forEach((f, i) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(f, now + i * dur);
      g.gain.setValueAtTime(0, now + i * dur);
      g.gain.linearRampToValueAtTime(gain, now + i * dur + 0.01);
      g.gain.exponentialRampToValueAtTime(0.001, now + i * dur + dur);
      osc.connect(g).connect(ctx.destination);
      osc.start(now + i * dur);
      osc.stop(now + i * dur + dur + 0.02);
    });
    // chiudi al termine
    setTimeout(() => ctx.close().catch(() => {}), (freqs.length * dur + 0.2) * 1000);
  },
};
